import {
  createComponentPreviewMapperModel,
  withCompPreviewInfo,
} from '@wix/editor-elements-integrations';

const css = withCompPreviewInfo()(
  ['componentViewMode'],
  ({ componentViewMode }) => {
    const isEditing = componentViewMode === 'editor';
    return {
      '--containerOutline': isEditing ? '1px dashed #868AA5' : 'none',
      height: 'auto',
      width: 'auto',
    };
  },
);

export default createComponentPreviewMapperModel({
  css,
});
